<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import TransactionNav from '@/components/Transaction/Nav';
  import TransactionInfo from '@/components/Transaction/Info';
  import TransactionAbout from '@/components/Transaction/About';
  import TransactionOrder from '@/components/Transaction/Order';
  import TransactionOffer from '@/components/Transaction/Offer';
  import TransactionHeader from '@/components/Transaction/Header';
  import TransactionMyOrder from '@/components/Transaction/MyOrder';
  import TransactionNegociate from '@/components/Transaction/Negociate';
  import TransactionChartArea from '@/components/Transaction/Chart/Area';
  import TransactionChartOrder from '@/components/Transaction/Chart/Order';
  import TransactionNotification from '@/components/Transaction/Notification';
  import TransactionChartCandlestick from '@/components/Transaction/Chart/Candlestick';

  export default {
    components: {
      TransactionNav,
      TransactionInfo,
      TransactionAbout,
      TransactionOffer,
      TransactionOrder,
      TransactionHeader,
      TransactionMyOrder,
      TransactionNegociate,
      TransactionChartArea,
      TransactionChartOrder,
      TransactionNotification,
      TransactionChartCandlestick,
    },

    data: () => ({
      notifications: [
        //
      ],
    }),

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),

      pro () {
        return this.$route.meta.pro;
      },
    },

    methods: {
      add (transaction) {
        this.notifications.push(transaction);
      },

      remove (id) {
        this.notifications.splice(
          this.notifications.findIndex(transaction => transaction.id == id),
          1,
        );
      },
    },
  };
</script>

<template>
  <main class="transaction">
    <TransactionNav />

    <transition-group name="list-fade" tag="div" class="transaction__notifications">
      <TransactionNotification
        v-bind="transaction"
        :key="transaction.id"
        @dismiss="remove(transaction.id)"
        v-for="transaction in notifications"
      />
    </transition-group>

    <TransactionHeader
      :pro="pro"
      />

    <section class="container" v-if="! pro">
      <div class="row">
        <TransactionChartArea
          class="col--8"
          />

        <TransactionNegociate
          class="col--4"
          @transaction="add"
          />
      </div>

      <div class="row">
        <TransactionOrder
          class="col--8"
          />

        <TransactionAbout
          class="col--4"
          />
      </div>
    </section>

    <section class="transaction__pro" v-else>
      <div class="row">
        <TransactionOffer
          class="col--4"
          />

        <div class="col--6">
          <TransactionChartCandlestick
            class="transaction__section"
            />

          <TransactionChartOrder
            class="transaction__section"
            />

          <TransactionMyOrder />
        </div>

        <div class="col--4">
          <TransactionNegociate
            pro
            @transaction="add"
            class="transaction__section"
            />

          <TransactionInfo />
        </div>
      </div>
    </section>
  </main>
</template>

<style lang="scss">
  .transaction {
    padding-bottom: 45px;

    .list-fade-enter-active,
    .list-fade-leave-active {
      transition: all 1s;
    }

    .list-fade-enter,
    .list-fade-leave-to {
      opacity: 0;
    }

    .list-fade-move {
      transition: all 1s;
    }

    .list-fade-leave-active:not(:last-child) {
      position: absolute;
    }

    &__section {
      margin-bottom: 16px;
    }

    &__pro {
      display: flex;
      justify-content: center;
    }

    &__notifications {
      top: 56px;
      z-index: 4;
      right: 56px;
      display: flex;
      position: absolute;
      flex-direction: column;

      > div {
        margin-bottom: 24px;
      }
    }

    &-table {
      text-align: left;

      &__title {
        opacity: 0.8;
        color: #FFF;
        margin-bottom: 8px;
        letter-spacing: 0.32px;
      }

      table {
        width: 100%;
        font-size: 13px;
        border-spacing: 0;
      }

      thead {
        th {
          width: 33%;
          color: #b2b8c5;
          font-weight: 400;
          padding-bottom: 6px;
          letter-spacing: 0.26px;
          border-bottom: solid 2px rgba(#979797, .18);
        }
      }

      tbody td {
        color: #FFF;
        padding: 8px 0;
        font-weight: 300;

        > span {
          position: relative;
        }
      }
    }
  }
</style>
